module.exports = __webpack_public_path__ + "assets/img/ab48a10950eae838f029946776133d17.png";